export enum RankingGroupingByTypeDTO {
    Individual = "Individual",
    Group = "Group"
}
